import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherGetPaymentSaga() {
  yield takeEvery("LOAD_PAYMENT", workerSaga);
}

function* workerSaga(action) {
  try {
    var payload = {};
    yield put({ type: "DISPLAY_LOADER", payload: payload });

    var formatUrl = "/api/Admin/get-card-types";
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "CARD_TYPE_DROPDOWN_LIST", payload: payload });

    formatUrl = "/api/Admin/get-accounts-dropdown";
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "ACCOUNT_DROPDOWN_LIST", payload: payload });

    formatUrl = "api/Admin/get-payment-types";
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PAYMENT_TYPE_DROPDOWN_LIST", payload: payload });

    var formatUrl = "api/Admin/get-account-types";
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "ACCOUNT_TYPE_DROPDOWN_LIST", payload: payload });

    formatUrl = "api/SalesTransactionV2/paid";
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    console.log(action.payload);
    yield put({ type: "PAYMENT_LIST", payload: payload });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
